module.exports = __webpack_public_path__ + "img/valueResult.3f5102ff.png";